import { create } from "zustand";
import { send_request } from "../../utils/Request";

const useAgentKnowledgeStore = create((set) => ({
  uploadKnowledgeFile: async (agentId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/knowledge/upload-file`,
        formData,
        "",
        "POST",
        { "content-type": "multipart/form-data" }
      );
      return response?.data || null;
    } catch (e) {
      set({ error: e.message || "Failed to upload knowledge file" });
      return null;
    }
  },

  deleteKnowledgeFile: async (agentId, fileId) => {
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/knowledge/file/${fileId}`,
        "",
        {},
        "DELETE"
      );
      return response?.data || null;
    } catch (e) {
      set({ error: e.message || "Failed to delete knowledge file" });
      return null;
    }
  },

  indexKnowledge: async (agentId) => {
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/knowledge/index`,
        {},
        {},
        "POST"
      );
      return response?.data || null;
    } catch (e) {
      set({ error: e.message || "Failed to index knowledge" });
      return null;
    }
  },

  deleteKnowledgeIndex: async (agentId) => {
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/knowledge/index`,
        "",
        {},
        "DELETE"
      );
      return response?.data || null;
    } catch (e) {
      set({ error: e.message || "Failed to delete knowledge index" });
      return null;
    }
  },

  fetchKnowledgeIndexStatus: async (agentId) => {
    try {
      const response = await send_request(
        `project-service/agent/${agentId}/knowledge/index-status`,
        "",
        {},
        "GET"
      );
      return response?.data || null;
    } catch (e) {
      set({ error: e.message || "Failed to load knowledge index status" });
      return null;
    }
  },
}));

export default useAgentKnowledgeStore;
